import { QaroniBaseFormsDirective } from '@qaroni-core/directives/qaroni-base-forms/qaroni-base-forms.directive';

export class ChecklistsListGlobalFilterForm extends QaroniBaseFormsDirective {
  private skeleton = {
    onlyCompanyWide: [false],
  };

  public form = this.fb.group(this.skeleton);

  get onlyCompanyWide() {
    return this.form.get('onlyCompanyWide');
  }

  get onlyCompanyWideValue() {
    return this.onlyCompanyWide.value;
  }

  set onlyCompanyWideValue(value: boolean | string) {
    const valStr = String(value);
    const convertValue =
      valStr === 'true' ? true : valStr === 'false' ? false : null;
    this.onlyCompanyWide.setValue(convertValue);
    this.onlyCompanyWide.markAsDirty();
  }

  public resetOnlyCompanyWide(): void {
    this.onlyCompanyWide.setValue(false);
  }
}
